import wcs from '@/scripts/libs/wcs'
import { WcsMentionMe } from '@/scripts/libs/wcs/types/wcs-config'
import { MentionMe, Situations } from '@/types/mention-me'
import Resources from '@/scripts/libs/resources'

export const getMentionMeUrlBySituation = (
  mentionMe: WcsMentionMe,
  situation: Situations
): string => {
  switch (situation) {
    case Situations.CHECKOUT:
      return mentionMe.referee?.src
    case Situations.LANDING_PAGE:
    case Situations.POSTPURCHASE:
      return mentionMe.referrer?.src
  }
}

export const buildMentionMeUrl = (
  mentionMeParams: MentionMe,
  locale: string,
  mentionMeUrl: string
): string => {
  let url = `${mentionMeUrl}?situation=${mentionMeParams.situation}&locale=${locale.replace(
    '-',
    '_'
  )}`
  if (mentionMeParams.implementation) {
    url += `&implementation=${mentionMeParams.implementation}`
  }
  if (mentionMeParams.firstName) {
    url += `&firstname=${encodeURIComponent(mentionMeParams.firstName)}`
  }
  if (mentionMeParams.surName) {
    url += `&surname=${encodeURIComponent(mentionMeParams.surName)}`
  }
  if (mentionMeParams.email) {
    url += `&email=${encodeURIComponent(mentionMeParams.email)}`
  }
  if (mentionMeParams.orderNumber) {
    url += `&order_number=${encodeURIComponent(mentionMeParams.orderNumber)}`
  }
  if (mentionMeParams.orderSubtotal) {
    url += `&order_subtotal=${encodeURIComponent(mentionMeParams.orderSubtotal)}`
  }
  if (mentionMeParams.orderCurrency) {
    url += `&order_currency=${encodeURIComponent(mentionMeParams.orderCurrency)}`
  }
  return url
}

export const loadMentionMeScript = (mentionMeParams: MentionMe) => {
  const { locale, mentionMe } = wcs.getStoreConfig()
  const mentionMeUrl = getMentionMeUrlBySituation(mentionMe, mentionMeParams.situation)
  const mentionMeScriptURl = buildMentionMeUrl(mentionMeParams, locale, mentionMeUrl)
  Resources.loadResourcesWithCallback({ resources: [{ src: mentionMeScriptURl }] })
}
